'use strict';

var _ = require('underscore'),
  moment = require('moment-timezone'),
  config = require('../config'),
  $global = require('../globalElements'),
  REGEX_START_LETTER = /(^[^a-z]+)/gi,
  REGEX_SAFE_CHARS = /([^-_:\.a-z0-9])/gi;

module.exports = function(Handlebars) {
  // Take a string and output a valid html id string
  Handlebars.registerHelper('safeId', function(str) {
    return new Handlebars.SafeString(str.replace(REGEX_START_LETTER, '').replace(REGEX_SAFE_CHARS, '-'));
  });

  // Concatenate all of the arguments
  Handlebars.registerHelper('concat', function() {
    return _.reduce(Array.prototype.slice.call(arguments, 0, -1), (str1, str2) => str1 + str2, '');
  });

  Handlebars.registerHelper('ifFeatureIsEnabled', function(featureId, options) {
    if ($global.$body.hasClass('feat-' + featureId)) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('ifFeatureIsNotEnabled', function(featureId, options) {
    if ($global.$body.hasClass('feat-' + featureId)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('momentFromNow', function(date) {
    return moment(date).locale(config.locale.code).fromNow();
  });

  Handlebars.registerHelper('ifEquals', function(con1, con2, options) {
    if (con1 === con2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/clientUtil.js